import SlideOptionApi from '@/api/slide-option'

// utils
import utils from '@/util'

const getSlideOptionsAction = async ({ commit, state }) => {
  const { slide, audienceId } = state
  const query = {
    pageSize: 250,
    slideId: slide.id,
    audienceId,
  }
  const result = await SlideOptionApi.getSlideOptions(query)

  const slideOptions = result.rows.map((item, key) => {
    item.index = key + 1
    item.color = utils.getAhaColor(key)
    return item
  })

  commit('setSlideOptions', slideOptions)
}

export default {
  getSlideOptionsAction,
}
